import { __ } from '@wordpress/i18n';
import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import Inspector from './InspectorControls';
import { getNoticeIcon } from './notice-types';
import { getIconClasses } from '../../utils/helpers';
import './style.scss';

/**
 * Notice.
 *
 * MIRRORS PHP: render.php builds the wrapper, the icon and the dismiss button;
 * this draws the same thing so the editor is not a surprise. The dismiss
 * button is deliberately inert here — an author who hides the notice in the
 * editor has no way to bring it back.
 */
const TEMPLATE = [
  [
    'core/paragraph',
    {
      content: __(
        'Orders placed after 3pm on Friday ship the following Monday.',
        'brandy-blocks'
      ),
      placeholder: __('Write the notice…', 'brandy-blocks'),
    },
  ],
];

export default function Edit({ attributes, setAttributes }) {
  const { type, showIcon, iconName, iconType, dismissible } = attributes;

  const blockProps = useBlockProps({
    className: [
      'brandy-notice',
      `is-type-${type}`,
      dismissible ? 'is-dismissible' : '',
    ]
      .filter(Boolean)
      .join(' '),
  });

  const innerBlocksProps = useInnerBlocksProps(
    { className: 'brandy-notice__content' },
    { template: TEMPLATE, templateLock: false }
  );

  const iconClasses = getIconClasses(getNoticeIcon(type, iconName), iconType);

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div {...blockProps}>
        {showIcon && (
          <i className={`brandy-notice__icon ${iconClasses}`} aria-hidden="true" />
        )}

        <div {...innerBlocksProps} />

        {dismissible && (
          <span className="brandy-notice__dismiss" aria-hidden="true">
            <i className="ph ph-x" />
          </span>
        )}
      </div>
    </>
  );
}
